import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { createSelector } from 'reselect';
import { 
    getActivityGroupByCode, 
    getActivityPeriodicityByCode, 
    getActivityPriorityByCode, 
    getActivityStatusByCode, 
    getActivityTypeByCode, 
    getPeriodicityByCode
} from '../../slices/thunks';

const useActivityMetadata = ({
    groupCode,
    statusCode,
    priorityCode,
    typeCode,
    activityPeriodicityCode,    
    normativePeriodicityCode,    
}) => {
    const dispatch = useDispatch();

    // Selectores para obtener los detalles de los diferentes elementos desde el slice Activities
    const selectorActivityMetadata = createSelector(
        state => state.Activities, // Acceder al slice de Activities
        (activities) => ({
            activityGroup: activities.itemActivityGroupDetail,
            activityStatus: activities.itemActivityStatusDetail,
            activityPriority: activities.itemActivityPriorityDetail,
            activityType: activities.itemActivityTypeDetail,
            activityPeriodicity: activities.itemActivityPeriodicityDetail,
        })
    );

    
    const { activityGroup, activityStatus, activityPriority, activityType, activityPeriodicity } = useSelector(selectorActivityMetadata);

    const selectorNormativeMetadata = createSelector(
        state => state.Periodicities, // Acceder al slice de Activities
        (activities) => ({
            normativePeriodicity: activities.itemPeriodicityDetail,
        })
    );

    const { normativePeriodicity } = useSelector(selectorNormativeMetadata);

    // Efectos para despachar las acciones que buscan los datos por código
    useEffect(() => {
        if (groupCode) {
            dispatch(getActivityGroupByCode(groupCode));
        }
        if (statusCode) {
            dispatch(getActivityStatusByCode(statusCode));
        }
        if (priorityCode) {
            dispatch(getActivityPriorityByCode(priorityCode));
        }
        if (typeCode) {
            dispatch(getActivityTypeByCode(typeCode));
        }
        if (activityPeriodicityCode) {
            dispatch(getActivityPeriodicityByCode(activityPeriodicityCode));
        }
        if (normativePeriodicityCode) {
            dispatch(getPeriodicityByCode(normativePeriodicityCode));
        }
    }, [dispatch, groupCode, statusCode, priorityCode, typeCode, activityPeriodicityCode, normativePeriodicityCode]);

    return { activityGroup, activityStatus, activityPriority, activityType, activityPeriodicity, normativePeriodicity};
};

export default useActivityMetadata;
